import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import pixels from "./pixels";
import config from "./config";
import VueLogger from "vuejs-logger";
import MQ from "vue-match-media/src";
import VueAnalytics from "vue-analytics";
import formValidator from "./mixins/form-validator";
import AdobeLaunch from "./store/plugins/adobe-launch";
import HTMLSanitize from "./store/plugins/html-sanitize";

import "./style/base.css";
import "./style/media.css";
import "./style/grid.css";

// Vue Logger
Vue.use(VueLogger, {
  isEnabled: true,
  logLevel: PRODUCTION ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true
});

// Configuración del módulo
Vue.use(config);
Vue.use(AdobeLaunch);

// Media queries
Vue.use(MQ);

// Pixeles
// (llamar al último)
Vue.use(pixels);

Vue.use(HTMLSanitize);

/**
 * Instanciar la app luego de obtener y
 * aplicar la configuración del módulo
 */
config.start(() => {
  // Inicializar la app
  const BBVA_APP = new Vue({
    router,
    store,
    mixins: [formValidator],
    mq: {
      medium: "(max-width: 1060px) and (min-width: 600px)",
      small: "(min-width: 600px)"
    },
    render: h => h(App),
    mounted: () => document.dispatchEvent(new Event("x-app-rendered"))
  }).$mount("#app");

  // Google Analytics
  // Necesitamso el config del id
  // por eso llamamos acá
  if (config.get() && config.get().googleAnalyticsId) {
    Vue.use(VueAnalytics, {
      id: config.get().googleAnalyticsId,
      router,
      autoTracking: {
        exception: true,
        pageviewOnLoad: false
      }
    });
  }

  // Agregar timestamp de versionado si existe
  let app_version = _BBVA_VERSION || null;
  if (app_version) {
    BBVA_APP.version = app_version;
  }

  // Exponemos la instancia al scope global
  // Útil para hacer modificaciones desde afuera
  window.BBVA_APP = BBVA_APP;
  return BBVA_APP;
});
